export class ImpresaDTO {
  denominazione: string;

  pi: string;

  cf: string;
}
